'use client';
import Product from '@models/product';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { ProductVariation } from '@typings/product';
import GrillCardInterior from './GrillCardInterior';
import { logProduct } from '@utils/productWrapper';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

interface Props {
  variation: ProductVariation | Product;
  selected: boolean;
  dark?: boolean;
}

const GrillCard = ({ variation, selected, dark }: Props) => {
  const { locale } = useCurrentUrl();
  if (!variation) return null;

  return (
    <li
      aria-current={selected ? 'true' : 'false'}
      role="group"
      aria-label="product"
      className={classNames(
        'tw-bg-white tw-w-full tw-items-center',
        selected && 'tw-border-4 tw-border-brand-300',
        !dark && !selected && 'tw-border-2 tw-border-neutral-200',
      )}
    >
      {!selected ? (
        <Anchor
          link={variation?.productUrl}
          onClick={() => {
            logProduct('PRODUCT_CLICKED', {
              product: variation as any,
              list_name: 'Grill Feature Comparison',
              locale,
              coupon_name: (variation as Product)?.promotionId,
            });
          }}
        >
          <GrillCardInterior variation={variation!} />
        </Anchor>
      ) : (
        <GrillCardInterior variation={variation} />
      )}
    </li>
  );
};

export default GrillCard;
